import { render, staticRenderFns } from "./_base-ve-table.vue?vue&type=template&id=60377216&scoped=true&"
import script from "./_base-ve-table.vue?vue&type=script&lang=js&"
export * from "./_base-ve-table.vue?vue&type=script&lang=js&"
import style0 from "./_base-ve-table.vue?vue&type=style&index=0&id=60377216&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60377216",
  null
  
)

export default component.exports